import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { defaultBillingDayOfWeek } from '~/constants';
import * as serviceModel from '../service/selectors';
import { makeBillUpfrontState } from './bill-upfront';
import { makeMaxCharges, makeOnApprovalBilling, makeOnDemandBilling, makeOneTimeInStagesBilling, makeOneTimeManualBilling, makeOngoingBilling, makeRepeatableManualBilling } from './makers';
import { PreapprovalPeriodType } from './model';
import * as selectors from './selectors';
import { isOnDemand, isRecurring } from './trigger-predicates';
export function setBillingDayOfWeek(billing, billingDayOfWeek) {
    return isRecurring(billing) && selectors.periodRequiresBillingDayOfWeek(billing.recurrencePeriod) ? _object_spread_props(_object_spread({}, billing), {
        billingDayOfWeek
    }) : billing;
}
export function setBillingDayOfMonth(billing, billingDayOfMonth) {
    return selectors.isMonthly(billing) && isRecurring(billing) ? _object_spread_props(_object_spread({}, billing), {
        billingDayOfMonth
    }) : billing;
}
export function setBillingDayOfYear(billing, billingDayOfYear) {
    return selectors.isYearly(billing) && isRecurring(billing) ? _object_spread_props(_object_spread({}, billing), {
        billingDayOfYear
    }) : billing;
}
export function setMaxCharges(billing, enabled, limit, chargesLeft) {
    if (isRecurring(billing) || isOnDemand(billing)) {
        return _object_spread_props(_object_spread({}, billing), {
            maxCharges: {
                enabled,
                limit,
                chargesLeft
            }
        });
    } else {
        return billing;
    }
}
export function deleteMaxCharges(billing) {
    if (isRecurring(billing) || isOnDemand(billing)) return _object_spread_props(_object_spread({}, billing), {
        maxCharges: makeMaxCharges(false)
    });
    return billing;
}
export function inputBillingDataToModel(param) {
    let { billingForm, originalService } = param;
    const { recurrencePeriod, trigger } = billingForm;
    if (recurrencePeriod === 'onetime') {
        if (trigger === 'approval') {
            return makeOnApprovalBilling();
        } else if (trigger === 'oneTimeInStages' && billingForm.oneTimeInStagesBilling) {
            return makeOneTimeInStagesBilling(billingForm.oneTimeInStagesBilling);
        } else {
            return makeOneTimeManualBilling();
        }
    } else if (recurrencePeriod === 'inStages') {
        if (!billingForm.oneTimeInStagesBilling) {
            throw new Error('bad billingForm');
        }
        return makeOneTimeInStagesBilling(billingForm.oneTimeInStagesBilling);
    } else if (recurrencePeriod === 'onDemand') {
        const maxCharges = originalService && serviceModel.maxCharges(originalService);
        const preapproval = originalService ? selectors.preapprovalPeriod(originalService.billing) : null;
        return makeOnDemandBilling(preapproval !== null && preapproval !== void 0 ? preapproval : PreapprovalPeriodType.None, {
            maxCharges
        });
    } else {
        const maxCharges = originalService && serviceModel.maxCharges(originalService);
        return trigger === 'ongoing' ? makeOngoingBilling(recurrencePeriod, {
            billingDayOfMonth: originalService ? serviceModel.billingDayOfMonth(originalService) : null,
            billingDayOfWeek: originalService ? serviceModel.billingDayOfWeek(originalService) || defaultBillingDayOfWeek : defaultBillingDayOfWeek,
            billingDayOfYear: originalService ? serviceModel.billingDayOfYear(originalService) || null : null,
            isBilledUpfront: originalService ? serviceModel.isBilledUpfront(originalService) : false,
            billUpfrontState: makeBillUpfrontState(!!(originalService && serviceModel.isSkipBillingOnAcceptance(originalService))),
            isPaused: originalService && serviceModel.isPaused(originalService),
            isProrated: originalService && serviceModel.isProrated(originalService),
            maxCharges,
            isAwaitingApproval: !originalService || serviceModel.isAwaitingApproval(originalService.status)
        }) : makeRepeatableManualBilling(recurrencePeriod, {
            maxCharges
        });
    }
}
